export const GET_ALL_PEOPLE = 'GET_ALL_PEOPLE';
export const GET_PERSON = 'GET_PERSON';
export const GET_PERSON_BY_ID = 'GET_PERSON_BY_ID';
export const CREATE_PERSON = 'CREATE_PERSON';
export const UPDATE_PERSON = 'UPDATE_PERSON';
export const DELETE_PERSON = 'DELETE_PERSON';
